export const SET_STATE = 'abandonedCart/SET_STATE';
export const SET_HYDRATING_STATUS = 'abandonedCart/SET_HYDRATING_STATUS';
export const GENERATE_SEARCH_UUID = 'abandonedCart/GENERATE_SEARCH_UUID';
export const RESET_STATE = 'abandonedCart/RESET_STATE';
